<button mat-button [matTooltip]=toolTip [matTooltipShowDelay]="toolTipDelay" [disabled]="disabled"
  [matTooltipClass]="'nxTooltip'" [ngClass]="width? width: ''">
  {{text}}
  <i *ngIf=icon [className]=icon></i>
</button>

